import { ISkeletonData, ITrackEntry, Spine } from "pixi-spine";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { IJackpotDisplay, IPixiJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { CreateElement, CreateSpineResources, Log, LogGroup, Safe, Scale, Size, shuffle } from "./MyHelpers";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { ScreenProtocol, ScreenProtocolScope } from "./ScreenProtocol";
import { JackpotDisplay, JackpotDisplayType, Settings } from "./Settings";
import { ZIndex } from "./ZIndex";
import * as PIXI from 'pixi.js';
import { JackpotText } from "./JackpotText";
import { JackPotTextParams } from "./JackPotTextParams";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "./ResourceManager/ResourceManager";
import { JSONResource } from "./ResourceManager/JSONResource";
import { AtlasResource } from "./ResourceManager/AtlasResource";
import { IRandomTimeout } from "./Context/RandomTimeout";
import { RegisterPixi, UnregisterPixi } from "./PixiDebug";
import { IInterval } from "./Context/Interval";
import { FrontendErrorCode, JackpotLevel } from "./api";
import { service } from "./services";
import { FontResource } from "./ResourceManager/FontResource";

interface JpAnimationSpine {
	spine : Spine,
	animation : string [];
}

export class JackpotDisplayDiamondPotStepShared extends IPixiJackpotDisplay {
	protected view: HTMLElement = null;
	protected viewSize: Size = null;
	protected commonpath: string = null;
	protected basepath: string = null;
	protected jackpot: string = null;
	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;
	protected screenProtocol: ScreenProtocol = null;
	protected logGroup: LogGroup;
	protected systemContext: ISystemContext = null;
	protected app: PIXI.Application<HTMLCanvasElement> = null;
	
	public get ViewPixiApp(): PIXI.Application<HTMLCanvasElement> {
		return this.app;
	}

	protected jp3textShared: JackpotText = null;
	protected jp4textShared: JackpotText = null;
	public constructor(params: JackpotDisplayParams) {
		super(params);
		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayDiamondPotStepShared");
		this.resid = params.resid.Add("JackpotDisplayDiamondPotStepShared");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayDiamondPotStepShared");
		this.screenProtocol = params.screenProtocol;
		this.jackpot = Settings.ResourcesFolder + `multigame/multigame/img/JackpotDisplay${JackpotDisplayType.DiamondPotStepShared}`;
		this.viewSize = params.viewSize;
		this.logGroup = new LogGroup("JackpotDisplayDiamondPotStepShared");

		// this would be "view" with jackpot frames
		this.view = CreateElement("div", {
			//classes: [this.resid.ID()],
			style: {
				position: "absolute",
				top: "0px",
				left: "0px",
				width: this.viewSize.Width + "px",
				height: this.viewSize.Height + "px",
				zIndex: "" + ZIndex.JackpotDisplay,
			}
		});
		this.view.className = this.resid.ID();

		this.restoreWebGlInterval = this.systemContext.TimingContext().CreateInterval("restoreWebGlInterval", 500, () => {
			let success = this.tryRecoverWebglContext();

			// success, stop timer
			if (!success)
			{
				this.recoverFailCount++;
				if (this.recoverFailCount == this.maxRecoverFailCount)
				{
					   void service.api.frontendError(FrontendErrorCode.WebGLRecoverFail, `${this.resid.ID()} in ${this.recoverFailCount} tries`);
				}
			}
		});
		
	}

	protected skeletonJP4: ISkeletonData;
	protected skeletonJP3: any;
	protected skeletonJP2: any;
	protected skeletonJP1: any;
	protected titleJackpotSkeletonData: ISkeletonData;
	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {
		// this.resourceJP4 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP4Spine/FrameJP4.json");
		// this.resourceJP3 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP3Spine/FrameJP3.json");
		// this.resourceJP2 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP2Spine/FrameJP2.json");
		// this.resourceJP1 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP1Spine/FrameJP1.json");
		if(loadingStage != LoadingStage.System) return ;
			await this.PrepareResourcesGamePreload(resourceManager);					
	}


	//Add atlas , json , to resource manager 
	protected async PrepareResourcesGamePreload(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		
		resourceManager.Add(new FontResource(this.jackpot + "/fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));		
		for (let jackpotLevel = 1; jackpotLevel <= 4; jackpotLevel++) {
			resourceManager.Add(new JSONResource(`${this.jackpot}/FramesSpine/JP${jackpotLevel}Spine/FrameJP${jackpotLevel}.json`, this.resid.ScopedResourceName(`JP${jackpotLevel}FrameSpineJson`)));
			resourceManager.Add(new AtlasResource(`${this.jackpot}/FramesSpine/JP${jackpotLevel}Spine/FrameJP${jackpotLevel}.atlas`, this.resid.ScopedResourceName(`JP${jackpotLevel}FrameSpineAtlas`)));
		}

		//Load Title Spine
		resourceManager.Add(new JSONResource(`${this.jackpot}/TitleSpine/JackpotTitle.json`, this.resid.ScopedResourceName(`JackpotTitleSpineJson`)));
		resourceManager.Add(new AtlasResource(`${this.jackpot}/TitleSpine/JackpotTitle.atlas`, this.resid.ScopedResourceName(`JackpotTitleSpineAtlas`)));		
	}

	protected canvasTextureJP4Value: PIXI.Sprite = null;
	protected canvasTextureJP4ValueShared: PIXI.Sprite = null;	
	protected canvasTextureJP3Value: PIXI.Sprite = null;
	protected canvasTextureJP3ValueShared: PIXI.Sprite = null;	
	protected canvasTextureJP2Value: PIXI.Sprite = null;
	protected canvasTextureJP1Value: PIXI.Sprite = null;

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.System) return;
		await this.ResourcesLoadedJackpotFramesSpinePreload(resourceManager);
		await this.ResourcesLoadedJackpotLevels(resourceManager)		
		await this.Create();
		await this.CreateSCreenShooTitle();
	}


	protected async ResourcesLoadedJackpotFramesSpinePreload(resourceManager: IReadOnlyResourceManager): Promise<void> {

			
		let titleJackpotJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`JackpotTitleSpineJson`));
		let assetTileJackpot = await PIXI.Assets.load(titleJackpotJson.path);
		this.titleJackpotSkeletonData = assetTileJackpot.spineData;
		
		let JP4FrameSpineJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`JP4FrameSpineJson`));
		let assetresourceJP4 = await PIXI.Assets.load(JP4FrameSpineJson.path);
		this.skeletonJP4 = assetresourceJP4.spineData;

		let JP3FrameSpineJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`JP3FrameSpineJson`));
		this.skeletonJP3 = await PIXI.Assets.load(JP3FrameSpineJson.path);

		let JP2FrameSpineJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`JP2FrameSpineJson`));
		this.skeletonJP2 = await PIXI.Assets.load(JP2FrameSpineJson.path);

		let JP1FrameSpineJson = resourceManager.Get<JSONResource>(this.resid.ScopedResourceName(`JP1FrameSpineJson`));
		this.skeletonJP1 = await PIXI.Assets.load(JP1FrameSpineJson.path);

		//move jackpot text for filling upated on fresh game 
		let jp4TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("White"),
			width: 1050,
			height: 162,
			color: "red",
			color2: "red",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
			colorStroke : "white",
		}


		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(333);
		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = Scale.Ypx(150); //84
		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";


		// Create shared jackpot
		let jp4TextSharedParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("White"),
			width: 629,
			height: 87.5,
			color: "red",
			color2: "red",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
			colorStroke: "white",
		}

		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp4s] = new JackpotText(jp4TextSharedParams);



		let jp3TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Red"),
			width: 687,
			height: 140,
			color: "purple",
			color2: "purple",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
			colorStroke : "white",
		}

		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);

		// Create shared jackpot
		let jp3TextSharedParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Red"),
			width: 629,
			height: 90,
			color: "purple",
			color2: "purple",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
			colorStroke : "white",
		}

		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp3s] = new JackpotText(jp3TextSharedParams);
		

		let jp2TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Blue"),
			width: 470,
			height: 80,
			color: "green",
			color2: "green",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
			colorStroke : "white",
		}

		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		//this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(250);
		//this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = Scale.Ypx(105);
		//this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";

		let jp1TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Green"),
			width: 512,
			height: 80,
			color: "blue",
			color2: "blue",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke: true,
			bold: true,
			colorStroke : "white",
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		//this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(111);
		//this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = Scale.Ypx(105);
		//this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";		
	}

	//protected arrayMapFrameSpine: Spine[] = [];

	protected jpSpineMap : Map<string ,JpAnimationSpine> = new Map<string ,JpAnimationSpine>();

	protected jpLevels : string [] = ["jp1","jp2","jp3","jp4"];
	protected ResourcesLoadedJackpotFrameSpine(): void {
		//let resourceJP4 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP4Spine/FrameJP4.json");
		let spineFrameJP4 = CreateSpineResources(this.skeletonJP4);
		spineFrameJP4.name = "JP4";
		spineFrameJP4.x = Scale.X(92);
		spineFrameJP4.y = Scale.Y(-76);		
		spineFrameJP4.state.setAnimation(0,"idle",true);
		//spineFrameJP4.scale.set(Scale.XY(0.70));
		this.app.stage.addChild(spineFrameJP4);
		//this.arrayMapFrameSpine.push(spineFrameJP4);		
		this.jpSpineMap.set("jp4",{
			spine: spineFrameJP4, animation:  spineFrameJP4.state.data.skeletonData.animations.map(s => s.name).filter(anim => anim.includes("RA"))
		});

		

		//spineFrameJP4.state.setAnimation(4,"animation",true);

		//let resourceJP3 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP3Spine/FrameJP3.json");
		let scale = Settings.Enable2plus1 == true ? 0.75 : 1 
		if(Settings.Screens == 2) scale= 0.75;
		let spineFrameJP3 = CreateSpineResources(this.skeletonJP3.spineData,  scale);
		spineFrameJP3.name = "JP3";

		let xPosition = Settings.Enable2plus1 == true ? Scale.X(542.5) : Scale.X(95);

		let yPosition = Settings.Enable2plus1 == true ?Scale.Y(364.5) : Scale.Y(280);

		if(Settings.Screens == 2){
			xPosition = Scale.X(542.5)
			yPosition = Scale.Y(364.5)
		} 


		spineFrameJP3.x = xPosition;
		spineFrameJP3.y = yPosition;
		spineFrameJP3.state.setAnimation(0,"idle",true);
		//spineFrameJP3.scale.set(Scale.XY(0.65));
		this.app.stage.addChild(spineFrameJP3);
		//spineFrameJP3.state.setAnimation(4,"animation",true);
		//this.arrayMapFrameSpine.push(spineFrameJP3);
		this.jpSpineMap.set("jp3",{
			spine: spineFrameJP3, animation:  spineFrameJP3.state.data.skeletonData.animations.map(s => s.name).filter(anim => anim.includes("RA"))
		});

		//let resourceJP2 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP2Spine/FrameJP2.json");
		let spineFrameJP2 = CreateSpineResources(this.skeletonJP2.spineData);
		spineFrameJP2.name = "JP2";
		spineFrameJP2.x = Scale.X(1059);
		spineFrameJP2.y = Scale.Y(679);
		spineFrameJP2.state.setAnimation(0,"idle",true);
		//spineFrameJP2.scale.set(Scale.XY(0.55));
		this.app.stage.addChild(spineFrameJP2);
		//spineFrameJP2.state.setAnimation(4,"animation",true);
		//this.arrayMapFrameSpine.push(spineFrameJP2);
		this.jpSpineMap.set("jp2",{
			spine: spineFrameJP2, animation:  spineFrameJP2.state.data.skeletonData.animations.map(s => s.name).filter(anim => anim.includes("RA"))
		});

		//let resourceJP1 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP1Spine/FrameJP1.json");
		let spineFrameJP1 = CreateSpineResources(this.skeletonJP1.spineData);
		spineFrameJP1.name = "JP1";
		spineFrameJP1.x = Scale.X(1059);
		spineFrameJP1.y = Scale.X(849);
		spineFrameJP1.state.setAnimation(0,"idle",true);
		//spineFrameJP1.scale.set(Scale.XY(0.50));
		this.app.stage.addChild(spineFrameJP1);
		//spineFrameJP1.state.setAnimation(4,"animation",true);
		//this.arrayMapFrameSpine.push(spineFrameJP1)
		this.jpSpineMap.set("jp1",{
			spine: spineFrameJP1, animation:  spineFrameJP1.state.data.skeletonData.animations.map(s => s.name).filter(anim => anim.includes("RA"))
		});

		this.Update();

		//Adding canvas into spine using pixie.js 
		//ADD VALUE JP4 INTO SPINE
		//this.jackpotTextMapping[JackpotLevel.Jp4].ResourcesLoaded();
		//this.jackpotTextMapping[JackpotLevel.Jp4].Start();
		// let canvas = this.jackpotTextMapping[JackpotLevel.Jp4].CanvasView();
		let textureCanvasJP4 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp4].CanvasView().Canvas());
		this.canvasTextureJP4Value = new PIXI.Sprite(textureCanvasJP4);
		this.canvasTextureJP4Value.width = textureCanvasJP4.width;
		this.canvasTextureJP4Value.height = textureCanvasJP4.height;
		//this.sprite.texture = texture;
		//spineFrameJP4.addChild(this.canvasTextureJP4Value);
		this.canvasTextureJP4Value.renderable = true;
		//this.sprite.texture.update();


		//this.view.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());
		let containersChildersIntoSpineJP4 = spineFrameJP4.children as PIXI.Container[];
		containersChildersIntoSpineJP4.forEach((container) => {
			if (container.name == "JPContainerValue") {
				//create container 
				let containerSpinnableReelsSpine = new PIXI.Container();
				containerSpinnableReelsSpine.name = "containerValue";
				//containerSpinnableReelsSpine.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width,positionSpinnableReelsSpinePivotContainer.height);
				containerSpinnableReelsSpine.scale.set(1, -1);
				containerSpinnableReelsSpine.position.x = 727.5;
				containerSpinnableReelsSpine.position.y = -153.19;

				container.addChild(containerSpinnableReelsSpine);
				containerSpinnableReelsSpine.addChild(this.canvasTextureJP4Value);
				//this.containerSpinnableReelsSpine.updateTransform();
			}
		});

		//create jackpot shared 
		let textureCanvasSharedJP4 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp4s].CanvasView().Canvas());
		this.canvasTextureJP4ValueShared = new PIXI.Sprite(textureCanvasSharedJP4);
		this.canvasTextureJP4ValueShared.width = textureCanvasSharedJP4.width;
		this.canvasTextureJP4ValueShared.height = textureCanvasSharedJP4.height;
		//this.sprite.texture = texture;
		//spineFrameJP3.addChild(this.canvasTextureJP4ValueShared);
		this.canvasTextureJP4ValueShared.renderable = true;
		//this.sprite.texture.update();


		//this.view.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());
		let containersChildersIntoSpineJP4Shared = spineFrameJP4.children as PIXI.Container[];
		containersChildersIntoSpineJP4Shared.forEach((container) => {
			if (container.name == "JPContainerShared") {
				//create container 
				let containerSpinnableReelsSpine = new PIXI.Container();
				containerSpinnableReelsSpine.name = "containerShared";
				//containerSpinnableReelsSpine.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width,positionSpinnableReelsSpinePivotContainer.height);
				containerSpinnableReelsSpine.scale.set(1, -1);
				containerSpinnableReelsSpine.position.x = 916;
				containerSpinnableReelsSpine.position.y = -360.55;

				container.addChild(containerSpinnableReelsSpine);
				containerSpinnableReelsSpine.addChild(this.canvasTextureJP4ValueShared);
				this.canvasTextureJP4ValueShared.texture.update();
				//this.containerSpinnableReelsSpine.updateTransform();
			}
		});


		//END ADD VALUE TO SPINE JP4

		//.........................................................................................//

		
		let textureCanvasJP3 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp3].CanvasView().Canvas());
		this.canvasTextureJP3Value = new PIXI.Sprite(textureCanvasJP3);
		this.canvasTextureJP3Value.width = textureCanvasJP3.width;
		this.canvasTextureJP3Value.height = textureCanvasJP3.height;
		//this.sprite.texture = texture;
		//spineFrameJP3.addChild(this.canvasTextureJP3Value);
		this.canvasTextureJP3Value.renderable = true;
		//this.sprite.texture.update();


		//this.view.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());
		let containersChildersIntoSpineJP3 = spineFrameJP3.children as PIXI.Container[];
		containersChildersIntoSpineJP3.forEach((container) => {
			if (container.name == "JPContainerValue") {
				//create container 
				let containerSpinnableReelsSpine = new PIXI.Container();
				containerSpinnableReelsSpine.name = "containerValue";
				//containerSpinnableReelsSpine.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width,positionSpinnableReelsSpinePivotContainer.height);
				containerSpinnableReelsSpine.scale.set(1, -1);
				containerSpinnableReelsSpine.position.x = 1090;
				containerSpinnableReelsSpine.position.y = -175.68;

				container.addChild(containerSpinnableReelsSpine);
				containerSpinnableReelsSpine.addChild(this.canvasTextureJP3Value);
				//this.containerSpinnableReelsSpine.updateTransform();
			}
		});

		//create jackpot shared 
		let textureCanvasSharedJP3 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp3s].CanvasView().Canvas());
		this.canvasTextureJP3ValueShared = new PIXI.Sprite(textureCanvasSharedJP3);
		this.canvasTextureJP3ValueShared.width = textureCanvasSharedJP3.width;
		this.canvasTextureJP3ValueShared.height = textureCanvasSharedJP3.height;
		//this.sprite.texture = texture;
		//spineFrameJP3.addChild(this.canvasTextureJP3ValueShared);
		this.canvasTextureJP3ValueShared.renderable = true;
		//this.sprite.texture.update();


		//this.view.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());
		let containersChildersIntoSpineJP3Shared = spineFrameJP3.children as PIXI.Container[];
		containersChildersIntoSpineJP3Shared.forEach((container) => {
			if (container.name == "JPContainerShared") {
				//create container 
				let containerSpinnableReelsSpine = new PIXI.Container();
				containerSpinnableReelsSpine.name = "containerShared";
				//containerSpinnableReelsSpine.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width,positionSpinnableReelsSpinePivotContainer.height);
				containerSpinnableReelsSpine.scale.set(1, -1);
				containerSpinnableReelsSpine.position.x = 1151.0;
				containerSpinnableReelsSpine.position.y = -324.94;

				container.addChild(containerSpinnableReelsSpine);
				containerSpinnableReelsSpine.addChild(this.canvasTextureJP3ValueShared);
				this.canvasTextureJP3ValueShared.texture.update();
				//this.containerSpinnableReelsSpine.updateTransform();
			}
		});


		//END ADD VALUE TO SPINE JP3


		//.............................................................................................//

		//ADD VALUE JP2 INTO SPINE		
		let textureCanvasJP2 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp2].CanvasView().Canvas());
		this.canvasTextureJP2Value = new PIXI.Sprite(textureCanvasJP2);
		this.canvasTextureJP2Value.width = textureCanvasJP2.width;
		this.canvasTextureJP2Value.height = textureCanvasJP2.height;
		//this.sprite.texture = texture;
		//spineFrameJP2.addChild(this.canvasTextureJP2Value);
		this.canvasTextureJP2Value.renderable = true;
		
		//this.sprite.texture.update();


		//this.view.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());
		let containersChildersIntoSpineJP2 = spineFrameJP2.children as PIXI.Container[];
		containersChildersIntoSpineJP2.forEach((container) => {
			if (container.name == "JPContainerValue") {
				//create container 
				let containerSpinnableReelsSpine = new PIXI.Container();
				containerSpinnableReelsSpine.name = "containerValue";
				//containerSpinnableReelsSpine.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width,positionSpinnableReelsSpinePivotContainer.height);
				containerSpinnableReelsSpine.scale.set(1, -1);
				containerSpinnableReelsSpine.position.x = 355;
				containerSpinnableReelsSpine.position.y = -98;
				container.addChild(containerSpinnableReelsSpine);
				containerSpinnableReelsSpine.addChild(this.canvasTextureJP2Value);
				//this.containerSpinnableReelsSpine.updateTransform();
			}
		});

		//END ADD VALUE TO SPINE JP2

		//ADD VALUE JP1 INTO SPINE
		//this.jackpotTextMapping[JackpotLevel.Jp1].ResourcesLoaded(resourceManager);
		//this.jackpotTextMapping[JackpotLevel.Jp1].Start();
		// let canvas = this.jackpotTextMapping[JackpotLevel.Jp4].CanvasView();
		let textureCanvasJP1 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp1].CanvasView().Canvas());
		this.canvasTextureJP1Value = new PIXI.Sprite(textureCanvasJP1);
		this.canvasTextureJP1Value.width = textureCanvasJP1.width;
		this.canvasTextureJP1Value.height = textureCanvasJP1.height;
		//this.sprite.texture = texture;
		//spineFrameJP1.addChild(this.canvasTextureJP1Value);
		this.canvasTextureJP1Value.renderable = true;
		//this.sprite.texture.update();


		//this.view.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());
		let containerchildrensSpine = spineFrameJP1.children as PIXI.Container[];
		containerchildrensSpine.forEach((container) => {
			if (container.name == "JPContainerValue") {
				//create container 
				let containerSpinnableReelsSpine = new PIXI.Container();
				containerSpinnableReelsSpine.name = "containerValue";
				//containerSpinnableReelsSpine.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width,positionSpinnableReelsSpinePivotContainer.height);
				containerSpinnableReelsSpine.scale.set(1, -1);
				containerSpinnableReelsSpine.position.x =314;
				containerSpinnableReelsSpine.position.y = -98;
				container.addChild(containerSpinnableReelsSpine);
				containerSpinnableReelsSpine.addChild(this.canvasTextureJP1Value);				
				//this.containerSpinnableReelsSpine.updateTransform();
			}
		});
		
		//END ADD VALUE TO SPINE JP1	

		this.CreateIntervalJackpot();
		this.Update();

		console.log("SpineJP:",this.jpSpineMap)
	}

	protected titleJackpotSpine : Spine = null;
	protected ResourcesLoadedTitleSpine(){
		this.titleJackpotSpine = CreateSpineResources(this.titleJackpotSkeletonData, 0.6);
		this.titleJackpotSpine.name = "titleJackpot";
		this.titleJackpotSpine.x = Scale.X(-2.5);
		this.titleJackpotSpine.y = Scale.Y(522.5);		
		this.titleJackpotSpine.state.setAnimation(0,"idle",true);
		this.app.stage.addChild(this.titleJackpotSpine);
	}

	protected async ResourcesLoadedJackpotLevels(resourceManager: IReadOnlyResourceManager)
	{		
		
		//ADD VALUE JP4 INTO SPINE
		this.jackpotTextMapping[JackpotLevel.Jp4]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4]?.Start();

		//ADD VALUE JP3Shared INTO SPINE
		this.jackpotTextMapping[JackpotLevel.Jp4s]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4s]?.Start();
		//this.jackpotTextMapping[JackpotLevel.Jp4s].SetTarget(21230);

		//ADD VALUE JP3 INTO SPINE
		this.jackpotTextMapping[JackpotLevel.Jp3]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3]?.Start();

		//ADD VALUE JP3Shared INTO SPINE
		this.jackpotTextMapping[JackpotLevel.Jp3s]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3s]?.Start();
		//this.jackpotTextMapping[JackpotLevel.Jp3s].SetTarget(125000);
		
		//ADD VALUE JP2 INTO SPINE
		this.jackpotTextMapping[JackpotLevel.Jp2]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2]?.Start();

		//ADD VALUE JP1 INTO SPINE
		this.jackpotTextMapping[JackpotLevel.Jp1]?.ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1]?.Start();

		this.jackpotTextMapping[JackpotLevel.Jp4]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp1]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2]?.Draw();


	}

	public override TitleHide() {
		//throw new Error("Method not implemented.");
		if(this.titleJackpotSpine == null) return;
		
		this.titleJackpotSpine.visible = false;
		this.titleJackpotSpine?.skeleton?.setBonesToSetupPose();
        this.titleJackpotSpine?.skeleton?.setToSetupPose();
        this.titleJackpotSpine?.skeleton?.setSlotsToSetupPose();

		if (this.titleJackpotSpine.state == null) return;
		this.titleJackpotSpine?.state?.clearTracks();
        this.titleJackpotSpine?.update(0);
	}
	public override TitleShow() {
		//throw new Error("Method not implemented.");
		if (this.titleJackpotSpine)
		{
			return;
		}

		this.titleJackpotSpine.visible = true;
		this.titleJackpotSpine.state?.setAnimation(0,"idle",true);
	}
	public override StartAnimations(): void {
		//throw new Error("Method not implemented.");
	}
	public override StopAnimations(): void {
		//throw new Error("Method not implemented.");
	}
	public override View(): HTMLElement {
		//throw new Error("Method not implemented.");
		return this.view;
	}
	public override Update(): void {
		this.canvasTextureJP4Value?.texture?.update();
		this.canvasTextureJP4ValueShared?.texture?.update();
		this.canvasTextureJP3Value?.texture?.update();
		this.canvasTextureJP3ValueShared?.texture?.update();
		this.canvasTextureJP2Value?.texture?.update();
		this.canvasTextureJP1Value?.texture?.update();
		this.jackpotTextMapping[JackpotLevel.Jp4]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp4s]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3s]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp1]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2]?.Draw();
		this.app?.ticker?.update();
		//throw new Error("Method not implemented.");
	}

	protected restoreWebGlInterval: IInterval = null;
	protected created: boolean = false;
	protected recoverCount: number = 0;
	protected recoverFailCount: number = 0;
	protected readonly maxRecoverFailCount = 5;
	protected webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);
	protected lostCount: number = 0;

	protected webglcontextlost() {
		this.lostCount++;
		Log.Error(this.logGroup, `Webgl context lost, count: ${this.lostCount}`);
		   void service.api.frontendError(FrontendErrorCode.WebGLContextLost, `${this.resid.ID()}, count: ${this.lostCount}`);

		// try recover right now, or start timer to try recover later
		let success = this.tryRecoverWebglContext();
		if (success) {
			// all good
			success = null;
			return;
		}

		// error recovering, start timer
		this.restoreWebGlInterval.Start();
	}

	protected async tryRecoverWebglContext(): Promise<boolean> {
		if (!this.created) {
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			// app not created, don't care
			return true;
		}

		console.log(this.resid.ID() + " trying to recover");
		   void service.api.frontendError(FrontendErrorCode.WebGLContextRecovering, `${this.resid.ID()}`);
		try {
			   void service.api.frontendError(FrontendErrorCode.WebGLDestroy, `${this.resid.ID()}`);
			this.InternalDestroy();
			   void service.api.frontendError(FrontendErrorCode.WebGLDestroySuccess, `${this.resid.ID()}`);
		}
		catch (ex) {
			   void service.api.frontendError(FrontendErrorCode.WebGLDestroyError, `${this.resid.ID()}: ${ex.toString()}`);
		}

		try {
			// Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
			   void service.api.frontendError(FrontendErrorCode.WebGLCreate, `${this.resid.ID()}`);
			this.InternalCreate();

			// all fine, stop timer
			this.restoreWebGlInterval.Stop();
			console.log(this.resid.ID() + " recover success");

			this.recoverCount++;
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			   void service.api.frontendError(FrontendErrorCode.WebGLCreateSuccess, `${this.resid.ID()}`);
			   void service.api.frontendError(FrontendErrorCode.WebGLContextRecovered, `${this.resid.ID()}, recover count: ${this.recoverCount}`);

			return true;
		}
		catch (ex) {
			   void service.api.frontendError(FrontendErrorCode.WebGLCreateError, `${this.resid.ID()}, ${ex.toString()}`);

			console.log(this.resid.ID() + " error recovering", ex);

			// prevent spamming the backend
			if (this.recoverFailCount < this.maxRecoverFailCount) {


				if (ex.message.toLowerCase().includes("this browser does not support webgl")) {
					   void service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}, error: ${ex.toString()}`);
				}
				else {
					   void service.api.frontendError(FrontendErrorCode.WebGLRecoverError, `${this.resid.ID()}, error: ${ex.toString()}`);
				}
			}
		}

		return false;
	};

	/** use for create App Pixi.js*/
	public Create() {
		
		this.created = true;

		try {
			this.InternalCreate();
		}
		catch (ex) {
			this.restoreWebGlInterval.Start();
		}


	}

	/** use for create pixi and registred for dont create multi times */
	public InternalCreate() {
		if (!this.created) {
			Log.Error(this.logGroup, `Create() FillingPot: app not null, don't recreate`);
			return;
		}


		// Log.Debug(this.logGroup, `Create(): creating reels`);
		this.app = new PIXI.Application({
			width: Scale.W(1920),
			height: Scale.H(1080),
			backgroundAlpha: 0,
			//resolution: 2,
    		//autoDensity: true,
    		//antialias: true,
			

			// backgroundColor : 0x0A0A0A,
		});
		this.app.stage.name = "PIXIContainer";
		this.app.view.style.position = "absolute";
		this.app.stage.accessibleChildren = true;
		this.app.stage.accessible = true
		this.app.stage.sortableChildren = true;
		this.app.stop();
		//this.app.render()


		RegisterPixi(this.app, this.resid);
		this.app.view.addEventListener("webglcontextlost", this.webglcontextlostInstance);
		//this.app.start(); // use custom ticker
		this.view.appendChild(this.app.view);





		//console.log("Spine-Created",this.resid.ID());
		// globalThis.__PIXI_APP__ = this.app;
		this.ResourcesLoadedTitleSpine();
		this.ResourcesLoadedJackpotFrameSpine()
		
	}

	/** use for destroy  App Pixi.js if that exist*/
	public Destroy() {
		this.InternalDestroy();
		this.created = false;
		this.restoreWebGlInterval.Stop();
	}

	public InternalDestroy() {

		if (!this.created) {
			Log.Debug(this.logGroup, `Destroy() FillingPot: no app, not destroying anything`);
			return;
		}

		// this.arrayMapFrameSpine.forEach((element) => {
		// 	Safe(() => { element.skeleton.setBonesToSetupPose() });
		// 	Safe(() => { element.skeleton.setToSetupPose() });
		// 	Safe(() => { element.state.update(0) });
		// 	Safe(() => { element.state.clearTracks() });
		// 	Safe(() => { element.state.clearListeners() });
		// 	Safe(() => { element.removeChildren(0, element.children.length) });
		// 	Safe(() => { element.removeFromParent() });
		// 	Safe(() => { element.destroy({ children: true }) });
		// })

		if (this.app != null) {
			//Safe(() =>this.arrayMapFrameSpine = []);
			Safe(() => this.changeRandomAnimationSpineInterval.Stop());
			Safe(() => this.changeRandomAnimationSpineInterval = null);
			Safe(() => { this.app.ticker.stop() });
			Safe(() => this.app.view.removeEventListener('webglcontextlost', this.webglcontextlostInstance));
			Safe(() => this.app.destroy(true, { children: true }));
			Safe(() => UnregisterPixi(this.app, this.resid));

			Safe(() => {
				var currentContext = this.app.view.getContext("webgl");
				currentContext?.getExtension("WEBGL_lose_context").loseContext()
			});
			Safe(() => {
				var currentContext = this.app.view.getContext("webgl2");
				currentContext?.getExtension("WEBGL_lose_context").loseContext()
			});

			this.app = null;
		}
		//console.log("Spine-Destroyed",this.resid.ID());
	}

	protected lastindexAnimInterval: number = -1;
	protected currentRandomAnimationIndex: number = -1;
	protected changeRandomAnimationSpineInterval: IRandomTimeout = null;
	protected animationRanbomTrack: ITrackEntry = null;
	protected CreateIntervalJackpot() {
		if(this.changeRandomAnimationSpineInterval != null) return;		
		this.changeRandomAnimationSpineInterval = this.systemContext.TimingContext().CreateRandomTimeout("changeAnimationInterval", 1500, 5000, () => {
			if (this.jpLevels.length > 0) {
				this.lastindexAnimInterval = this.currentRandomAnimationIndex;
				if (this.currentRandomAnimationIndex == this.jpLevels.length - 1) {
					this.jpLevels = shuffle(this.jpLevels);
					//console.log("DoAnotherShuffledAnimation:", this.jpLevels);
				}
				this.currentRandomAnimationIndex = this.jpLevels.randomIndex();
				this.animationRanbomTrack = this.jpSpineMap.get(this.jpLevels[this.currentRandomAnimationIndex]).spine.state.setAnimation(1,this.jpSpineMap.get(this.jpLevels[this.currentRandomAnimationIndex]).animation.random(),false)
				this.changeRandomAnimationSpineInterval.ChangeTimeoutFromTo((this.animationRanbomTrack?.animationEnd  * 1000) + 1500, (this.animationRanbomTrack?.animationEnd * 1000) + 5000);
				this.lastindexAnimInterval = this.currentRandomAnimationIndex;
				this.changeRandomAnimationSpineInterval.Start();
			}
		});
		this.changeRandomAnimationSpineInterval.Start();
	}

	protected imgConverted: HTMLImageElement = null;
	protected async CreateSCreenShooTitle() {		
	
	}

	public override GetSImgTitleJackpotSpine(): HTMLImageElement {

		let spine = CreateSpineResources(this.titleJackpotSkeletonData);
		//spine.width = this.spinnableReels.GetSymbolSize().width;
		//spine.height = this.spinnableReels.GetSymbolSize().height;
		//spine.scale.set(0.5);
		spine.position.set(0, 0);
		spine.autoUpdate = true;
		spine.update(0);
		let renderTexture = PIXI.RenderTexture.create({ width: 1920, height: 1080 });
		// Render Spine object onto render texture
		let renderer = new PIXI.Renderer({
			width: 1920, height: 1080
		});
		renderer.render(spine, { renderTexture: renderTexture });
		// Create a new Sprite using the RenderTexture                
		// Extract the canvas                
		//let canvas = renderer.plugins.extract.canvas(new PIXI.Sprite(renderTexture)) as HTMLCanvasElement;

		//let img = renderer.plugins.extract.img()
		// //create img div empty
		this.imgConverted = CreateElement("img", {
			style: {
				//width: "100%",
				//height: "100%",
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundOrigin: "center",
			}
		});
		//add img src from data img saved 
		this.imgConverted.src = (renderer.plugins.extract.canvas(new PIXI.Sprite(renderTexture)) as HTMLCanvasElement).toDataURL("image/png", 1.0);
		this.imgConverted.style.transform = "scale(1.5)";
		//spine.autoUpdate = true;
		//renderer.destroy(true);
		//renderer.clear();
		//renderTexture.destroy(true);
		//spine.autoUpdate = false;
		//spine.destroy(true);
		//imgConverted = null;
		return this.imgConverted
	}

	public override GetSpineSkeleton (){
		return this.titleJackpotSkeletonData;
	}
}
